import { render, staticRenderFns } from "./ForgotLogin.vue?vue&type=template&id=221a5bd0&scoped=true&"
import script from "./ForgotLogin.js?vue&type=script&lang=js&"
export * from "./ForgotLogin.js?vue&type=script&lang=js&"
import style0 from "./ForgotCredentials.scss?vue&type=style&index=0&id=221a5bd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a5bd0",
  null
  
)

export default component.exports